import * as React from 'react'
require('../base.module.scss')
import { BaseComponentProps } from '../Common/extractClassNamesFromProps'
import { extractClassNamesFromProps } from '../Common/extractClassNamesFromProps'
import * as st from './Toggle.module.scss'

interface ToggleProps extends BaseComponentProps {
  onChange: () => any,
  checked?: boolean,
  customID?: string,
  size?: 's'|'l',
  dark?: boolean
}

interface ToggleState {
  isChecked: boolean
}

export class Toggle extends React.Component<ToggleProps, ToggleState> {
  displayName = 'Toggle'
  toggleID: string
  constructor(props: ToggleProps) {
    super(props)
    this.state = {
      isChecked: Boolean(props.checked)
    }
    this.toggleID = props.customID || Math.random().toString(36).slice(2)
  }

  static getDerivedStateFromProps(props: ToggleProps){
    return {
      isChecked: props.checked
    }
  }

  render() {
    const { props, state } = this
    const className = extractClassNamesFromProps(props, st.toggle, props.dark ? st.dark : '')
    return (
      <label htmlFor={this.toggleID}>
      <div className={className}>
        <input checked={state.isChecked}
          onChange={() => {
            this.setState({
              isChecked: !state.isChecked
            })
            props.onChange()
          }} id={this.toggleID} type="checkbox" />
        <span className={`${st.circle} ${st[`size-${props.size || 'l'}`]}`}></span>
        </div>
        {props.children}
      </label>
    )
  }
}